export type PublicHolidayDate = { date: string; descriptor: string };
export type PublicHolidayQuery = { from: string; to: string };
export type PublicHolidayDates = { days: PublicHolidayDate[]; missingYears: number[] };

export function publicHolidayNamesByDate(days: readonly PublicHolidayDate[]): ReadonlyMap<string, string> {
  const names = new Map<string, Set<string>>();
  for (const { date, descriptor } of days) {
    const name = descriptor.trim();
    if (!name) continue;
    const existing = names.get(date) ?? new Set<string>();
    existing.add(name);
    names.set(date, existing);
  }
  return new Map([...names].map(([date, descriptors]) => [date, [...descriptors].join(' · ')]));
}

/** 화면 시연용 일부 일정이다. 실제 서비스는 저장된 공휴일 조회만 사용한다. */
export function fixturePublicHolidayDates({ from, to }: PublicHolidayQuery): PublicHolidayDates {
  const days: PublicHolidayDate[] = [];
  for (let year = Number(from.slice(0, 4)); year <= Number(to.slice(0, 4)); year += 1) {
    for (const [monthDay, descriptor] of [
      ['01-01', '1월 1일'], ['03-01', '삼일절'], ['05-05', '어린이날'], ['06-06', '현충일'],
      ['08-15', '광복절'], ['10-03', '개천절'], ['10-09', '한글날'], ['12-25', '기독탄신일'],
    ]) {
      const date = `${year}-${monthDay}`;
      if (date >= from && date <= to) days.push({ date, descriptor });
    }
  }
  for (const date of ['2026-09-24', '2026-09-25', '2026-09-26']) {
    if (date >= from && date <= to) days.push({ date, descriptor: '추석' });
  }
  return { days: days.sort((left, right) => left.date.localeCompare(right.date)), missingYears: [] };
}
